export const questions = [
  {
    prompt: "How would you like your skin to feel after you cleanse?",
    optionA: "Clean",
    optionB: "Hydrated",
    optionC: "Both",
  },
  {
    prompt: "What is your main skin concern?",
    optionA: "Dark Under Eye Circles",
    optionB: "Acne Scars",
    optionC: "Acne",
  },
  {
    prompt: "What is your secondary skin concern?",
    optionA: "Uneven (pigmentation spots)",
    optionB: "Lines & Wrinkles",
    optionC: "Flaky/Rough Skin",
  },
  {
    prompt: "How would you describe your skin?",
    optionA: "Oily",
    optionB: "Dry",
    optionC: "Combination",
    optionD: "Balanced",
  },
  {
    prompt: "How much time do you spend in the sun?",
    optionA: "Less than 3 hours per week",
    optionB: "About 24 hours per week",
    optionC: "More than 48 hours per week",
  },
];
